<template>
  <v-row
    no-gutters
    class="d-flex flex-row justify-center fill-height"
    :class="isDoneQuestionary ? 'ma-0 ma-md-n3' : ' '"
  >
    <v-col
      v-if="$vuetify.breakpoint.mdAndUp || isDoneQuestionary"
      :class="isDoneQuestionary ? 'ma-0 ma-md-n3 ' : ' '"
      cols="12"
      :md="isDoneQuestionary ? '12' : '6'"
      sm="12"
    >
      <v-card
        class="d-flex justify-center apresentationColumn rounded-0"
        width="100%"
        height="100%"
        flat
      >
        <v-col
          class="apresentationColumnContent"
          :cols="
            $vuetify.breakpoint.mdAndUp
              ? isDoneQuestionary
                ? 'auto'
                : '8 '
              : '12'
          "
        >
          <div class="d-flex flex-column" v-if="!isDoneQuestionary">
            <span class="prepAccount d-flex-inline">{{
              $t('message.pages.welcomePanda.prepAccount')
            }}</span>
            <span class="whileFinish d-flex-inline align-center">
              {{ $t('message.pages.welcomePanda.prepAccountSub') }}</span
            >
          </div>
          <div class="d-flex flex-column" v-else>
            <img
              src="@/assets/logo-symbol-pandavideo.svg"
              class="iconComplete mb-10 mb-md-5 mr-0"
            />
            <span class="prepAccount d-flex-inline">{{
              $t('message.pages.welcomePanda.prepAccountDone')
            }}</span>
            <span class="whileFinish d-flex-inline align-center">
              {{ $t('message.pages.welcomePanda.prepAccountSubDone') }}</span
            >
          </div>

          <span class="whileFinish d-flex-inline align-center mt-7 d-flex">
            <v-progress-circular
              v-if="isLoadingPreferences"
              :size="18"
              :width="3"
              color="gray"
              class="mr-1"
              indeterminate
            ></v-progress-circular>
            <img
              v-else
              src="@/assets/snackbar/icons/check-round.svg"
              class="mr-1 checkIcon"
            />
            {{
              $t('message.pages.welcomePanda.prepAccountStages.settingAccount')
            }}</span
          >
          <span class="whileFinish d-flex align-center mt-4 d-flex">
            <v-progress-circular
              v-if="isLoadingPreferences"
              :size="18"
              :width="3"
              color="gray"
              class="mr-1"
              indeterminate
            ></v-progress-circular>
            <img
              v-else
              src="@/assets/snackbar/icons/check-round.svg"
              class="mr-1 checkIcon"
            />
            {{
              $t(
                'message.pages.welcomePanda.prepAccountStages.loadingPreferences'
              )
            }}</span
          >
          <span class="whileFinish d-flex-inline align-center mt-4 d-flex">
            <v-progress-circular
              v-if="isLoadingEndingAdjusts"
              :size="18"
              :width="3"
              color="gray"
              class="mr-1"
              indeterminate
            ></v-progress-circular>
            <img
              v-else
              src="@/assets/snackbar/icons/check-round.svg"
              class="mr-1 checkIcon"
            />
            {{
              $t(
                'message.pages.welcomePanda.prepAccountStages.customizingPlayer'
              )
            }}</span
          >
          <span class="whileFinish d-flex-inline align-center mt-4 d-flex">
            <v-progress-circular
              v-if="isLoadingCreateAccount"
              :size="18"
              :width="3"
              color="gray"
              class="mr-1"
              indeterminate
            ></v-progress-circular>
            <img
              v-else
              src="@/assets/snackbar/icons/check-round.svg"
              class="mr-1 checkIcon"
            />
            {{
              $t(
                'message.pages.welcomePanda.prepAccountStages.addedCreditBonus'
              )
            }}</span
          >
          <span class="whileFinish d-flex-inline align-center mt-4 d-flex">
            <v-progress-circular
              v-if="!isCompleteAllSteps"
              :size="18"
              :width="3"
              color="gray"
              class="mr-1"
              indeterminate
            ></v-progress-circular>
            <img
              v-else
              src="@/assets/snackbar/icons/check-round.svg"
              class="mr-1 checkIcon"
            />
            {{
              $t('message.pages.welcomePanda.prepAccountStages.endingAdjusts')
            }}</span
          >
        </v-col>
      </v-card>
    </v-col>
    <v-col cols="12" md="6" sm="12" v-if="!isDoneQuestionary">
      <v-card
        class="d-flex justify-center questionaryColumn rounded-0"
        width="100%"
        height="100%"
        flat
      >
        <v-col
          :cols="$vuetify.breakpoint.mdAndUp ? '9' : '12'"
          class="d-flex flex-column"
        >
          <div class="mb-10 mt-16">
            <v-row class="col-auto pa-md-0">
              <v-icon
                v-if="currentQuestion > 0"
                @click="backQuestion"
                class="cursor-pointer backQuestion"
                >mdi-arrow-left</v-icon
              >
            </v-row>
            <SkipQuestionary
              @skippedQuestion="(skipped) => handleSkippedQuestion(skipped)"
            ></SkipQuestionary>
            <v-row>
              <v-col class="col-auto px-md-0 pt-md-4">
                <img
                  v-if="$vuetify.theme.dark"
                  height="40"
                  class="mousePointer"
                  src="../../assets/logoWhite.svg"
                />
                <img
                  v-else
                  height="40"
                  class="mousePointer"
                  src="../../assets/logoBlack.svg"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="px-md-0 pb-md-0 question">
                <span> {{ questions[currentQuestion].question }} </span>
              </v-col>
              <v-col cols="12" class="pa-md-0 questionSub">
                <span v-if="questions[currentQuestion].isMultiple">
                  {{ $t('message.pages.welcomePanda.moreThanTwoOptions') }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="px-md-0">
                <v-chip-group
                  column
                  v-model="selectedOption"
                  :multiple="questions[currentQuestion].isMultiple"
                >
                  <v-chip
                    v-for="(option, i) in questions[currentQuestion].options"
                    :key="i"
                    class="d-flex align-center"
                  >
                    <span
                      class="d-inline-flex mr-1 icon-chip"
                      v-if="option.icon"
                      ><v-icon>mdi-{{ option.icon }}</v-icon></span
                    >
                    {{ option.name }}
                  </v-chip>
                </v-chip-group>
                <v-input
                  v-if="
                    isOtherOption &&
                    !questions[currentQuestion].isDescribe &&
                    !questions[currentQuestion].options[selectedOption]
                      .subQuestions
                  "
                  v-model="otherOption"
                  :messages="handleAnswerError"
                  :label="$t('message.pages.welcomePanda.whereYouHeardAbout')"
                  :error="errors.invalidAnswer"
                  class="mt-6"
                ></v-input>
                <v-textarea
                  v-else-if="
                    isOtherOption && questions[currentQuestion].isDescribe
                  "
                  v-model="otherOption"
                  :messages="handleAnswerError"
                  :error="errors.invalidAnswer"
                  :label="
                    $t('message.pages.welcomePanda.describeYourBussiness')
                  "
                  :placeholder="
                    $t(
                      'message.pages.welcomePanda.describeYourBussinessPlaceholder'
                    )
                  "
                  :counter="5000"
                  maxlength="5000"
                  class="mt-6"
                >
                </v-textarea>

                <div
                  class="mt-4"
                  v-if="
                    questions[currentQuestion].options[selectedOption] &&
                    questions[currentQuestion].options[selectedOption]
                      .subQuestions
                  "
                >
                  <span class="subquestion">{{
                    $t('message.pages.welcomePanda.plataforms.whatPlataformUse')
                  }}</span>
                  <v-chip-group
                    column
                    v-model="selectedSubOption"
                    :multiple="questions[currentQuestion].isMultiple"
                    class="mt-n2"
                  >
                    <v-chip
                      v-for="(subquestion, i) in questions[currentQuestion]
                        .options[selectedOption].subQuestions"
                      :key="i"
                      @click="checkIfOther(subquestion.value)"
                    >
                      {{ subquestion.plataform }}
                    </v-chip>
                  </v-chip-group>

                  <div
                    v-if="
                      questions[currentQuestion].options[selectedOption]
                        .subQuestions && this.isOtherOption
                    "
                  >
                    <v-input
                      v-model="otherOption"
                      :messages="handlePlataformError"
                      :label="
                        $t('message.pages.welcomePanda.whatYourPlataform')
                      "
                      :placeholder="
                        $t('message.pages.welcomePanda.actions.insertHere')
                      "
                      :error="errors.invalidAnswer"
                      class="mt-8"
                    ></v-input>
                  </div>

                  <v-textarea
                    :class="this.isOtherOption ? 'mt-4' : 'mt-7'"
                    :counter="5000"
                    maxlength="5000"
                    :error="errors.invalidAnswer"
                    :messages="handleExperieceError"
                    :label="
                      $t(
                        'message.pages.welcomePanda.plataforms.howWasYourExperienceThere'
                      )
                    "
                    :placeholder="
                      $t(
                        'message.pages.welcomePanda.plataforms.placeholderDescribeExperience'
                      )
                    "
                    v-model="describeExperience"
                  ></v-textarea>
                </div>

                <span
                  v-if="
                    errors.isNotMultiple &&
                    !questions[currentQuestion].isMultiple
                  "
                  class="errorMsg"
                  >{{
                    $t('message.pages.welcomePanda.errors.selectJustOne')
                  }}</span
                >
                <span v-if="errors.anyOptionSelected" class="errorMsg">{{
                  $t('message.pages.welcomePanda.errors.anyOptionSelected')
                }}</span>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col
                class="col-auto px-md-0"
                :class="isOtherOption ? 'py-md-1' : ''"
              >
                <base-btn
                  v-if="currentQuestion < questions.length - 1"
                  type="primary"
                  class="mr-2"
                  @click="nextQuestion(questions[currentQuestion].isMultiple)"
                  >{{ $t('message.pages.welcomePanda.actions.next') }}</base-btn
                >
                <base-btn
                  v-else
                  type="primary"
                  class="mr-2"
                  :loading="loadingSubscription"
                  @click="nextQuestion()"
                  >{{ $t('message.pages.welcomePanda.actions.send') }}</base-btn
                >
                <base-btn
                  type="tertiary"
                  @click="skipQuestion"
                  v-if="currentQuestion < questions.length - 1"
                  >{{ $t('message.pages.welcomePanda.actions.skip') }}</base-btn
                >
                <base-btn
                  v-else
                  ref="endQuestionarySkippingBtn"
                  type="tertiary"
                  @click="skipQuestion"
                >
                  {{ $t('message.pages.welcomePanda.actions.skip') }}
                </base-btn>
              </v-col>
            </v-row>
          </div>
          <v-row class="mb-md-10">
            <v-col
              class="flex-column flex-md-row align-md-end d-flex align-center justify-center justify-md-space-between px-md-0"
            >
              <div
                class="d-flex flex-column align-center flex-md-row ga-4 ga-md-0"
              >
                <span class="mr-md-4 d-inline-flex">
                  <a
                    :href="helpLink"
                    target="_blank"
                    type="secondary"
                    size="xsmall"
                  >
                    {{ $t('message.help') }}
                  </a>
                </span>
                <span class="d-inline-flex mt-4 mt-md-0">
                  <a
                    href="https://pandavideo.com.br/privacy/"
                    target="_blank"
                    type="secondary"
                    size="xsmall"
                  >
                    {{ $t('message.privacyPolicy') }}
                  </a>
                </span>
              </div>
              <div
                class="d-flex flex-column-reverse flex-md-row align-center mt-4"
              >
                <img
                  src="@/assets/logo-symbol-pandavideo.svg"
                  width="24px"
                  class="iconFooter mt-4 mt-md-0 mr-0 mr-md-2"
                />
                <span class="helpLinks d-inline-flex">
                  &copy; {{ getYear }} Panda Video
                </span>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import linkHelper from '@/utils/linkHelper.mixin.js'
import i18n from '@/translations/lang'
import planApi from '@/services/planApi'
import videosApi from '@/services/videosApi'
import SkipQuestionary from '../../components/skipQuestionary.vue'

export default {
  name: 'Welcome',
  mixins: [linkHelper],
  components: { SkipQuestionary },
  data: () => ({
    isDoneQuestionary: false,
    isCompleteAllSteps: false,
    otherOption: '',
    currentQuestion: 0,
    selectedOption: null,
    loadingSubscription: false,
    describeExperience: '',
    userInfos: {},
    selectedSubOption: false,
    wasSkipped: false,
    isOtherOption: false,
    isLoadingPreferences: false,
    isLoadingEndingAdjusts: false,
    isLoadingCreateAccount: false,
    answers: [],
    errors: {
      isNotMultiple: false,
      anyOptionSelected: false,
      invalidAnswer: false,
    },
    questions: [
      {
        options: [
          { name: 'Google', value: 'google' },
          { name: 'Youtube', value: 'youtube' },
          { name: 'Instagram', value: 'instagram' },
          { name: 'Facebook', value: 'facebook' },
          { name: 'TikTok', value: 'tiktok' },
          { name: 'E-mail', value: 'email' },
          {
            name: i18n.t('message.pages.welcomePanda.answers.memberArea'),
            value: 'courses',
          },
          {
            name: i18n.t('message.pages.welcomePanda.plataforms.influencer'),
            value: 'influencer',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.others'),
            value: 'others',
          },
        ],
        isMultiple: false,
        question: i18n.t('message.pages.welcomePanda.howMetPanda'),
      },
      {
        options: [
          {
            name: i18n.t('message.pages.welcomePanda.answers.CurseEad'),
            value: 'course',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.VSL'),
            value: 'vsl',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.dubbing'),
            value: 'dubbings',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.livesAndWebnars'),
            value: 'lives',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.Demos'),
            value: 'demos',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.aiChats'),
            value: 'aiChats',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.playlists'),
            value: 'playlists',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.offlineApp'),
            value: 'offlineApp',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.others'),
            value: 'others',
          },
        ],
        isDescribe: true,
        isMultiple: true,
        question: i18n.t('message.pages.welcomePanda.whatYouWillHost'),
      },
      {
        options: [
          {
            name: i18n.t('message.pages.welcomePanda.answers.alreadyHave'),
            value: true,
            icon: 'thumb-up-outline',
            subQuestions: [
              { plataform: 'Vimeo', value: 'vimeo' },
              { plataform: 'Youtube', value: 'youtube' },
              {
                plataform: i18n.t(
                  'message.pages.welcomePanda.plataforms.other'
                ),
                value: 'others',
              },
            ],
            describeExperience: '',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.dontHave'),
            icon: 'thumb-down-outline',
            value: false,
          },
        ],
        isMultiple: false,
        question: i18n.t('message.pages.welcomePanda.alreadyUseSomePlataform'),
      },
      {
        options: [
          {
            name: i18n.t('message.pages.welcomePanda.answers.1/50'),
            value: '1/50',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.50/200'),
            value: '50/200',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.200+'),
            value: '200+',
          },
          {
            name: i18n.t('message.pages.welcomePanda.answers.none'),
            value: '0',
          },
        ],
        isMultiple: false,
        question: i18n.t('message.pages.welcomePanda.howManyVideos'),
      },
    ],
  }),
  computed: {
    helpLink() {
      return this.getHelpLink()
    },
    getYear() {
      const date = new Date()
      return date.getFullYear()
    },
    handlePlataformError() {
      if (this.errors.invalidAnswer) {
        return i18n.t('message.pages.welcomePanda.errors.insertValidPlataform')
      }
      return ''
    },
    handleAnswerError() {
      if (this.errors.invalidAnswer) {
        return i18n.t('message.pages.welcomePanda.errors.insertValidAnswer')
      }
      return ''
    },
    handleExperieceError() {
      if (this.errors.invalidAnswer) {
        return i18n.t('message.pages.welcomePanda.errors.insertValidExperience')
      }
      return ''
    },
    questionErrorMessage() {
      if (this.errors.isNotMultiple) {
        return i18n.t('message.pages.welcomePanda.errors.selectJustOne')
      }
      if (this.errors.anyOptionSelected) {
        return i18n.t('message.pages.welcomePanda.errors.anyOptionSelected')
      }
      return ''
    },
  },
  mounted() {
    this.loadingsAccountCreate()
    this.$crisp.push(['do', 'chat:hide'])
  },
  watch: {
    selectedOption: {
      deep: true,
      handler(option) {
        if (!option) return
        if (typeof option === 'object' && !option.length) return
        let selectedOption
        if (typeof option === 'number')
          selectedOption = this.questions[this.currentQuestion].options[option]

        if (typeof option === 'object') {
          selectedOption =
            this.questions[this.currentQuestion].options[
              option[option.length - 1]
            ]
        }
        this.checkIfOther(selectedOption.value)
      },
    },
  },
  methods: {
    handleSkippedQuestion(skipped) {
      if (skipped) {
        this.wasSkipped = skipped
        if (this.currentQuestion === this.questions.length - 1)
          return this.nextQuestion('finalQuestion')
        this.currentQuestion++
        this.initialState()
      }
    },
    loadingsAccountCreate() {
      this.isLoadingPreferences = true
      this.isLoadingEndingAdjusts = true
      this.isLoadingCreateAccount = true
      setTimeout(() => {
        this.isLoadingPreferences = false
      }, 2000)
      setTimeout(() => {
        this.isLoadingEndingAdjusts = false
      }, 4000)
      setTimeout(() => {
        this.isLoadingCreateAccount = false
      }, 6000)
    },
    checkIfOther(optionValue) {
      if (optionValue === 'others' && !this.isOtherOption) {
        this.isOtherOption = true
      } else if (optionValue === 'others') {
        this.isOtherOption = false
      } else if (this.selectedOption?.length > 0 && this.selectedOption[0]) {
        this.isOtherOption = this.selectedOption.some(
          (obj) =>
            this.questions[this.currentQuestion].options[obj].value === 'others'
        )
      } else {
        this.isOtherOption = false
      }
    },
    skipQuestion() {
      this.$root.$emit('skipQuestionary', {})
    },
    initialState() {
      this.isOtherOption = false
      this.otherOption = ''
      this.selectedOption = null
      this.errors.anyOptionSelected = false
      this.errors.isNotMultiple = false
      this.errors.invalidAnswer = false
    },
    completeQuestionary() {
      this.isDoneQuestionary = true
      setTimeout(() => {
        this.isCompleteAllSteps = true
      }, 1000)
      setTimeout(() => {
        this.$router.push({ name: 'Videos' })
      }, 2000)
      this.loadingSubscription = false
    },
    async updateUser() {
      this.loadingSubscription = true
      try {
        await planApi.updateSubscription({
          client_questions: {
            ...this.userInfos,
            skipped_questions: this.wasSkipped,
          },
        })
        this.verifyAccount()
      } catch (e) {
        console.error(e)
      }
    },
    async verifyAccount() {
      const subscription = await this.checkStripe()
      if ((await this.checkLibrary()) && subscription) {
        this.completeQuestionary()
      } else {
        setTimeout(() => {
          this.verifyAccount()
        }, 2000)
      }
    },
    async checkStripe() {
      try {
        return await planApi.getSubscription()
      } catch (e) {
        return false
      }
    },
    async checkLibrary() {
      try {
        await videosApi.getVideos()
        return true
      } catch (e) {
        return false
      }
    },
    backQuestion() {
      this.initialState()
      this.currentQuestion--
    },
    async nextQuestion(param) {
      const end_questionary = param === 'finalQuestion'

      let answersSelecteds = []
      if (end_questionary) {
        localStorage.removeItem('firstAccess')
        this.$refs.endQuestionarySkippingBtn.$el.style.visibility = 'hidden'
        await this.updateUser()
        return
      }
      if (
        this.selectedOption &&
        typeof this.selectedOption === 'object' &&
        !this.selectedOption.length
      )
        return (this.errors.anyOptionSelected = true)

      if (
        !this.selectedOption &&
        !this.questions[this.currentQuestion].options[this.selectedOption] &&
        !this.questions[this.currentQuestion].options[this.selectedOption]
          ?.subQuestions
      )
        return (this.errors.anyOptionSelected = true)
      if (this.isOtherOption && this.otherOption.length < 3)
        return (this.errors.invalidAnswer = true)

      if (this.selectedOption.length > 0) {
        this.selectedOption.forEach((option) => {
          let selectedAnswer =
            this.questions[this.currentQuestion].options[option]

          if (selectedAnswer.value === 'others' && this.otherOption) {
            selectedAnswer = { ...selectedAnswer, value: this.otherOption }
          }

          answersSelecteds.push(selectedAnswer.value)
        })

        this.userInfos = {
          ...this.userInfos,
          customer_goals: answersSelecteds.join(' - '),
        }
      } else if (this.selectedOption) {
        let selectedAnswer =
          this.questions[this.currentQuestion].options[this.selectedOption]

        if (selectedAnswer.value === 'others' && this.otherOption)
          selectedAnswer = { ...selectedAnswer, value: this.otherOption }

        answersSelecteds.push(selectedAnswer)
        !this.currentQuestion
          ? (this.userInfos = {
              ...this.userInfos,
              from_lead: selectedAnswer.value,
            })
          : (this.userInfos = {
              ...this.userInfos,
              expected_videos: selectedAnswer.value,
            })
      } else {
        !this.currentQuestion
          ? (this.userInfos = {
              ...this.userInfos,
              from_lead: 'google',
            })
          : (this.userInfos = {
              ...this.userInfos,
              expected_videos: '1/50',
            })
      }

      if (
        this.questions[this.currentQuestion].options[this.selectedOption] &&
        this.questions[this.currentQuestion].options[this.selectedOption]
          ?.subQuestions
      ) {
        if (!this.selectedSubOption && this.selectedSubOption !== 0)
          return (this.errors.anyOptionSelected = true)
        if (!this.describeExperience.length)
          return (this.errors.invalidAnswer = true)
        let competitorPlataform =
          this.questions[this.currentQuestion].options[this.selectedOption]
            .subQuestions[this.selectedSubOption].value

        if (competitorPlataform === 'others')
          competitorPlataform = this.otherOption

        this.userInfos = {
          ...this.userInfos,
          competitor: `${competitorPlataform} - ${this.describeExperience}`,
        }
      }

      this.answers.push(answersSelecteds)
      this.initialState()
      if (this.currentQuestion < this.questions.length - 1) {
        this.currentQuestion++
      } else {
        localStorage.removeItem('firstAccess')
        this.$refs.endQuestionarySkippingBtn.$el.style.visibility = 'hidden'
        await this.updateUser()
      }
    },
  },
}
</script>

<style lang="scss">
.iconComplete {
  width: 80px;
}
.questionaryColumn {
  background: $neutral-100-white-light;

  .question {
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    color: $neutral-20-dark-light;
  }
  .questionSub {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    color: $neutral-40-light-light;
  }

  &.theme--dark {
    background: $neutral-100-white-dark;

    .question {
      color: $neutral-100-white-light;
    }
    .questionSub {
      color: $neutral-40-light-light;
    }
    .subquestion {
      color: $neutral-100-white-light;
    }
  }
  .subquestion {
    line-height: 12px;
    font-size: 12px;
    font-weight: 500;
    color: $neutral-20-dark-light;
  }
}
.helpLinks {
  font-size: 12px;
}
.crisp-client .cc-1brb6 .cc-1yy0g .cc-1m2mf .cc-157aw {
  width: 40px;
  height: 40px;
}
.checkIcon {
  background: white;
  border-radius: 50px;
}
.errorMsg {
  font-weight: 400;
  line-height: 18px;
  font-size: 14px;
  color: $feedback-danger-light;
}
.backQuestion {
  font-size: 24px;
  color: $neutral-70-light !important;
}
.theme--dark.backQuestion {
  font-size: 24px;
  color: $neutral-70-dark !important;
}
.icon-chip .v-icon {
  font-size: 20px !important;
  color: $neutral-30-base-light;
}
.bg-dark .icon-chip .v-icon {
  font-size: 20px !important;
  color: $neutral-30-base-dark;
}
.apresentationColumn {
  background: linear-gradient(90deg, #3f55ee 0%, #8594ff 100%) !important;

  .apresentationColumnContent {
    margin-top: 30dvh;

    .prepAccount {
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 120%;
      color: $neutral-100-white-light;
    }
    .whileFinish {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%;
      color: $neutral-100-white-light;
    }
  }

  &.theme--dark {
    background: linear-gradient(90deg, #070f4b 0%, #000f75 100%) !important;
  }
  @media only screen and (max-width: 960px) {
    margin-top: 0rem;
  }
}
</style>
